import React from 'react'
import pageStyles from '../CreatorsProgramPage/styles.module.css'
import Text from '../../../Text'
import { $textPrimary } from '../../../../styles/colors/semantics'
import Spacer from '../../../Spacer'
import styles from './styles.module.css'
import Youtube from '../../../Youtube'
import SpecsTable from '../../Products/Utils/ItemSpecifications/SpecsTable'
import heroStyles from '../Hero/styles.module.css'

function Step4() {
  return (
    <div className={pageStyles.stepWrapper}>
      <div className={pageStyles.stepContentWrapper}>
        <div className={pageStyles.stepTitle}>
          <Text type="heading-1">04</Text>
        </div>
        <div className={pageStyles.stepTextWrapper}>
          <Text type="heading-2" color={$textPrimary.dark}>What will we expect from you</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textPrimary.dark}>As part of the VRS Creators Program, we have specific monthly content requirements designed to ensure consistent, high-quality, and engaging material that showcases the best of what VRS has to offer. Here’s what we expect from you each month:</Text>
          <Spacer size={32}/>
          <Text type="heading-4" color={$textPrimary.dark}>Vertical shorts</Text>
          <Spacer size={8}/>
          <div className={styles.shorts}>
            <Youtube url={'https://www.youtube.com/watch?v=eyx6qPKHLNA'} height="400"/>
            <Youtube url={'https://www.youtube.com/shorts/_Mf7McOeWZ0'} height="400"/>
            <Youtube url={'https://www.youtube.com/watch?v=hDtNFf7hNR4'} height="400"/>
          </div>
          <Spacer size={8}/>
          <SpecsTable specs={[
            { name: 'Min quantity', value: '3' },
            { name: 'Min quality', value: '1080p' },
            { name: 'Time ', value: '30-40 secs' },
            { name: 'Used for', value: 'Stories, posts, etc.' },
          ]} theme="dark"/>
          <Spacer size={32}/>
          <Text type="heading-4" color={$textPrimary.dark}>Horizontal video</Text>
          <Spacer size={8}/>
          <div className={heroStyles.videoWrapper}>
            <Youtube url={'https://www.youtube.com/watch?v=hQZdt-3jE-8'} height="500"/>
          </div>
          <SpecsTable specs={[
            { name: 'Min quantity', value: '1' },
            { name: 'Min quality', value: '1080p' },
            { name: 'Time ', value: '5-8 min' },
            { name: 'Used for', value: 'YouTube,  cut for shorter videos, etc' },
          ]} theme="dark"/>
        </div>
      </div>
    </div>
  )
}

export default Step4
